var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstructor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12871_67163",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H34V34H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12871_67163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 6.68508V5.78594C3.18359 4.62648 4.12324 3.68684 5.2827 3.68684H6.05766C6.40562 2.85676 7.22508 2.27438 8.18066 2.27438H11.6657C13.5436 2.27438 15.0663 3.79641 15.0663 5.67437V10.8262",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18359 10.8262V9.00989",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29297 19.5957V16.6898",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.957 19.5957V16.6898",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12391 13.2344H3.80906C3.09918 13.2344 2.52344 12.6586 2.52344 11.9488C2.52344 11.2382 3.09918 10.6631 3.80906 10.6631H5.12391",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.6631H14.4398C15.1497 10.6631 15.7255 11.2382 15.7255 11.9487C15.7255 12.6586 15.1497 13.2344 14.4398 13.2344H13.125",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1222 7.81546V13.2699C13.1222 15.358 11.4294 17.0508 9.34121 17.0508H8.9014C6.81359 17.0508 5.12109 15.3583 5.12109 13.2705V7.07696C5.12109 6.50135 5.58773 6.03472 6.16334 6.03472H6.81498C7.04023 6.03472 7.26117 6.09222 7.45972 6.19841C9.02173 7.03393 10.8227 7.42347 12.5911 7.31802C12.8787 7.30088 13.1222 7.5272 13.1222 7.81546Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1266 14.16C9.88531 14.3935 9.56032 14.5371 9.20192 14.5371H9.04573C8.68734 14.5371 8.36235 14.3935 8.12109 14.16",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6914 27.7681V31.0449",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43659 31.0449H17.7504V22.0469C17.7504 20.6929 16.652 19.5952 15.2987 19.5952H2.94922",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7852 5.43508V16.2832C17.7852 16.4666 17.9338 16.6152 18.1172 16.6152H32.1748C32.3582 16.6152 32.5068 16.4666 32.5068 16.2832V5.43508",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 5.10156V4.17493C16.7891 3.99158 16.9377 3.8429 17.1211 3.8429H33.1704C33.3537 3.8429 33.5024 3.99158 33.5024 4.17493V5.10156C33.5024 5.28491 33.3537 5.43359 33.1704 5.43359H17.1211C16.9377 5.43359 16.7891 5.28491 16.7891 5.10156Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17563 28.8889L3.72289 31.4596C3.42221 31.6332 3.08114 31.7246 2.73391 31.7246H2.47804C1.38559 31.7246 0.5 30.839 0.5 29.7466V22.0454C0.501195 20.6927 1.59869 19.5959 2.95172 19.5959H4.01747",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2389 27.6976L11.7688 26.8144L10.2389 24.1646L3.55859 28.0215V25.6922",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8868 14.5362L14.375 23.1816",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2383 24.1628L12.4699 22.8743C13.2017 22.4518 14.1373 22.7026 14.5598 23.4342C14.9822 24.166 14.7315 25.1017 13.9998 25.5241L11.7681 26.8125",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.125 19.5943L10.348 21.6483C10.4543 21.8268 10.6965 21.865 10.8526 21.7279L13.2798 19.5943",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12743 19.5943L7.90443 21.6483C7.79818 21.8268 7.55593 21.865 7.39994 21.7279L4.97266 19.5943",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2148 16.6143V18.25",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2131 18.2517C24.6251 18.2517 24.1484 18.7283 24.1484 19.3162C24.1484 19.9042 24.6251 20.3809 25.2131 20.3809C25.801 20.3809 26.2776 19.9042 26.2776 19.3162C26.2776 18.7283 25.801 18.2517 25.2131 18.2517Z",
    stroke: "#0A5EF3",
    strokeWidth: 0.996094,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructor);
export default __webpack_public_path__ + "static/media/instructor.01da42262fd4f7b18b1ec2b5551a30b6.svg";
export { ForwardRef as ReactComponent };